export default __webpack_public_path__ + "static/media/add-stop.8065cfe4.svg";